import { AirdropInfo } from '../../types'
import { DynamicAirdropBadge } from './DynamicAirdropBadge'

export function AirdropBadge({
  isError,
  className,
  closeMobileMenu,
}: AirdropInfo & { className?: string; closeMobileMenu: () => void }) {
  if (isError) {
    return null
  }

  return <DynamicAirdropBadge className={className} closeMobileMenu={closeMobileMenu} />
}
